import { render, staticRenderFns } from "./preguntas-lista-item.vue?vue&type=template&id=2ac3b7a6&scoped=true&"
import script from "./preguntas-lista-item.vue?vue&type=script&lang=ts&"
export * from "./preguntas-lista-item.vue?vue&type=script&lang=ts&"
import style0 from "./preguntas-lista-item.vue?vue&type=style&index=0&id=2ac3b7a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac3b7a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCol,VImg,VRow,VSpacer})
